import { useEffect, useRef, useState } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { fundingPaths } from "../../routes/funding";
import { enterPrisesPaths } from "../../routes/enterprises";
const FundingExploreProject = () => {
  const user = { name: "founder-coaching", role: "coach" };
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  //   const [navBarDemo, setNavBarDemo] = useState("Founder");

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    dispatch(fetchCoachList());
  }, []);

  const displayUsers = coachList?.filter((item) => {
    const matchCoachingType = item?.category_name
      ?.toLowerCase()
      .includes("founder");
    return matchCoachingType;
  });

  if (isLoading2) {
    return <Loader />;
  }
  return (
    <MenuLayout user={user}>
      {({ openSignUp }) => (
        <>
          <section
            class="ct_px_40 mt-4   ct_dark_sky_bg py-5"
            style={{ backgroundColor: "#023047" }}
          >
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-xxl-5 col-xl-5 col-md-4 mb-4 mb-md-0"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_boocamp_img_left">
                    <img
                      src="../assets/img/funding_explore_project_left_img.png"
                      alt=""
                      class="ct_img_h_458 w-100"
                    />
                  </div>
                </div>

                <div
                  class="col-xxl-7 col-xl-7 col-md-8 mb-4 mb-md-0 "
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_px_40 ct_px_0_767">
                    <h2
                      class="ct_fs_50_new mb-4 text-white"
                      style={{ maxWidth: "600px" }}
                    >
                      Explore <span className="ct_yellow_text">Funding</span>{" "}
                      Opportunities
                    </h2>
                    <p
                      class="mb-0 mt-3 ct_fs_20 text-white "
                      style={{ maxWidth: "648px" }}
                    >
                      Discover carefully vetted projects that are ready for
                      investment and support. Use filters to find the perfect
                      match based on category, stage, or impact area.
                    </p>
                    <div class="ct_mt_40">
                      <a class="ct_yellow_btn   px-5 ct_fit_content ct_h_48">
                        Explore Project
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            className="ct_coach_created_bg cy_py_100 ct_px_100 mt-0 "
            style={{ backgroundColor: "#EEEEEE" }}
          >
            <div className="container">
              <div className="row ">
                <div className="col-xxl-8 col-xl-9 col-lg-12 col-md-10 mx-auto">
                  <h2 className="ct_fs_32 text-center mb-0">
                    Find a Project To Invest
                  </h2>

                  <div className="position-relative mt-4 mx-lg-5">
                    <input
                      type="search"
                      className="form-control ct_input ct_input_ps_40 bg-transparent"
                      placeholder="Search by coach name"
                    />
                    <i className="fa-solid fa-search ct_input_icon_left"></i>
                  </div>

                  <div className="d-flex align-items-center gap-3 mt-4 flex-wrap ct_flex_col_767 ct_w_100_767 justify-content-center">
                    <div className="ct_w_100_767">
                      <div className="d-flex flex-column gap-2 position-relative">
                        <select className="form-control ct_input bg-transparent ct_fit_content ct_w_100_767">
                          <option>Category</option>
                          <option>Tech</option>
                          <option>Education</option>
                          <option>Health</option>
                          <option>Sustainability</option>
                        </select>
                        <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                      </div>
                    </div>
                    <div className="ct_w_100_767">
                      <div className="d-flex flex-column gap-2 position-relative">
                        <select className="form-control ct_input bg-transparent ct_fit_content ct_w_100_767">
                          <option>Stage</option>
                          <option>Idea</option>
                          <option>Seed</option>
                          <option>Growth</option>
                        </select>
                        <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                      </div>
                    </div>
                    <div className="ct_w_100_767">
                      <div className="d-flex flex-column gap-2 position-relative">
                        <select className="form-control ct_input bg-transparent ct_fit_content ct_w_100_767">
                          <option>Funding Type</option>
                          <option>Equity</option>
                          <option>Grant</option>
                          <option>Co-investment</option>
                          <option>Expansion</option>
                        </select>
                        <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                      </div>
                    </div>
                    <div className="ct_w_100_767">
                      <div className="d-flex flex-column gap-2 position-relative">
                        <select className="form-control ct_input bg-transparent ct_fit_content ct_w_100_767">
                          <option>Impact Area</option>
                          <option>Environment</option>
                          <option>Community</option>
                          <option>Education</option>
                          <option>Health</option>
                        </select>
                        <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                      </div>
                    </div>
                    <div className="ct_w_100_767">
                      <div className="d-flex flex-column gap-2 position-relative">
                        <select className="form-control ct_input bg-transparent ct_fit_content ct_w_100_767">
                          <option>Location</option>
                          <option>Local</option>
                          <option>Regional</option>
                          <option>Global</option>
                        </select>
                        <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                      </div>
                    </div>
                    <div className="position-relative ct_w_100_767">
                      <img
                        src="../assets/img/filter_circle_icon.png"
                        className=""
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row gx-md-5 ct_mt_60">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 ct_mb_60">
                  <div class="ct_project_card">
                    <div className="ct_project_card_border_1">
                      <div class="ct_project_img">
                        <img
                          src="../assets/img/project_img_1.png"
                          alt="Solar Learning Initiative"
                        />
                        <span class="ct_verified_badge">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_47963)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#34C759"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_47963">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Verified
                        </span>
                      </div>

                      <div class="ct_project_content">
                        <h4 class="ct_fs_24_new ct_orange_text mb-5">
                          Solar Learning Initiative
                        </h4>

                        <p class="ct_fs_16 ct_darkblue_text ct_mb_16">
                          Empowering rural schools through solar-powered
                          learning tools
                        </p>

                        <p
                          class="ct_darkblue_text mb-0"
                          style={{ maxWidth: "400px" }}
                        >
                          This mobile education kit brings digital learning to
                          off-grid communities using solar tech and offline
                          content.
                        </p>

                        <div class="ct_project_footer flex-wrap ct_mt_20">
                          <div class="ct_project_owner">
                            <img
                              src="../assets/img/girl_7789.png"
                              alt="Olivia Brooks"
                              className="ct_img_40"
                            />
                            <span className="ct_fs_14 ct_darksky_blue_text">
                              Led by Olivia Brooks
                            </span>
                          </div>

                          <a
                            href="#"
                            class="ct_yellow_btn ct_darkblue_btn ct_h_44"
                            onClick={() =>
                              navigate(fundingPaths.FundingProjectFullDetail)
                            }
                          >
                            View Project
                            <i class="fa-solid fa-arrow-right ms-1"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 ct_mb_60">
                  <div class="ct_project_card">
                    <div className="ct_project_card_border_1">
                      <div class="ct_project_img">
                        <img
                          src="../assets/img/project_img_2.png"
                          alt="Solar Learning Initiative"
                        />
                        <span class="ct_verified_badge">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_47963)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#34C759"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_47963">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Verified
                        </span>
                      </div>

                      <div class="ct_project_content">
                        <h4 class="ct_fs_24_new ct_orange_text mb-5">
                          Solar Learning Initiative
                        </h4>

                        <p class="ct_fs_16 ct_darkblue_text ct_mb_16">
                          Empowering rural schools through solar-powered
                          learning tools
                        </p>

                        <p
                          class="ct_darkblue_text mb-0"
                          style={{ maxWidth: "400px" }}
                        >
                          This mobile education kit brings digital learning to
                          off-grid communities using solar tech and offline
                          content.
                        </p>

                        <div class="ct_project_footer flex-wrap ct_mt_20">
                          <div class="ct_project_owner">
                            <img
                              src="../assets/img/girl_7789.png"
                              alt="Olivia Brooks"
                              className="ct_img_40"
                            />
                            <span className="ct_fs_14 ct_darksky_blue_text">
                              Led by Olivia Brooks
                            </span>
                          </div>

                          <a
                            href="#"
                            class="ct_yellow_btn ct_darkblue_btn ct_h_44"
                            onClick={() =>
                              navigate(fundingPaths.FundingProjectFullDetail)
                            }
                          >
                            View Project
                            <i class="fa-solid fa-arrow-right ms-1"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 ct_mb_60">
                  <div class="ct_project_card">
                    <div className="ct_project_card_border_1">
                      <div class="ct_project_img">
                        <img
                          src="../assets/img/project_img_3.png"
                          alt="Solar Learning Initiative"
                        />
                        <span class="ct_verified_badge">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_47963)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#34C759"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_47963">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Verified
                        </span>
                      </div>

                      <div class="ct_project_content">
                        <h4 class="ct_fs_24_new ct_orange_text mb-5">
                          Solar Learning Initiative
                        </h4>

                        <p class="ct_fs_16 ct_darkblue_text ct_mb_16">
                          Empowering rural schools through solar-powered
                          learning tools
                        </p>

                        <p
                          class="ct_darkblue_text mb-0"
                          style={{ maxWidth: "400px" }}
                        >
                          This mobile education kit brings digital learning to
                          off-grid communities using solar tech and offline
                          content.
                        </p>

                        <div class="ct_project_footer flex-wrap ct_mt_20">
                          <div class="ct_project_owner">
                            <img
                              src="../assets/img/girl_7789.png"
                              alt="Olivia Brooks"
                              className="ct_img_40"
                            />
                            <span className="ct_fs_14 ct_darksky_blue_text">
                              Led by Olivia Brooks
                            </span>
                          </div>

                          <a
                            href="#"
                            class="ct_yellow_btn ct_darkblue_btn ct_h_44"
                            onClick={() =>
                              navigate(fundingPaths.FundingProjectFullDetail)
                            }
                          >
                            View Project
                            <i class="fa-solid fa-arrow-right ms-1"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 ct_mb_60">
                  <div class="ct_project_card">
                    <div className="ct_project_card_border_1">
                      <div class="ct_project_img">
                        <img
                          src="../assets/img/project_img_4.png"
                          alt="Solar Learning Initiative"
                        />
                        <span class="ct_verified_badge">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_47963)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#34C759"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_47963">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Verified
                        </span>
                      </div>

                      <div class="ct_project_content">
                        <h4 class="ct_fs_24_new ct_orange_text mb-5">
                          Solar Learning Initiative
                        </h4>

                        <p class="ct_fs_16 ct_darkblue_text ct_mb_16">
                          Empowering rural schools through solar-powered
                          learning tools
                        </p>

                        <p
                          class="ct_darkblue_text mb-0"
                          style={{ maxWidth: "400px" }}
                        >
                          This mobile education kit brings digital learning to
                          off-grid communities using solar tech and offline
                          content.
                        </p>

                        <div class="ct_project_footer flex-wrap ct_mt_20">
                          <div class="ct_project_owner">
                            <img
                              src="../assets/img/girl_7789.png"
                              alt="Olivia Brooks"
                              className="ct_img_40"
                            />
                            <span className="ct_fs_14 ct_darksky_blue_text">
                              Led by Olivia Brooks
                            </span>
                          </div>

                          <a
                            href="#"
                            class="ct_yellow_btn ct_darkblue_btn ct_h_44"
                            onClick={() =>
                              navigate(fundingPaths.FundingProjectFullDetail)
                            }
                          >
                            View Project
                            <i class="fa-solid fa-arrow-right ms-1"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 ct_mb_60">
                  <div class="ct_project_card">
                    <div className="ct_project_card_border_1">
                      <div class="ct_project_img">
                        <img
                          src="../assets/img/project_img_5.png"
                          alt="Solar Learning Initiative"
                        />
                        <span class="ct_verified_badge">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_47963)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#34C759"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_47963">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Verified
                        </span>
                      </div>

                      <div class="ct_project_content">
                        <h4 class="ct_fs_24_new ct_orange_text mb-5">
                          Solar Learning Initiative
                        </h4>

                        <p class="ct_fs_16 ct_darkblue_text ct_mb_16">
                          Empowering rural schools through solar-powered
                          learning tools
                        </p>

                        <p
                          class="ct_darkblue_text mb-0"
                          style={{ maxWidth: "400px" }}
                        >
                          This mobile education kit brings digital learning to
                          off-grid communities using solar tech and offline
                          content.
                        </p>

                        <div class="ct_project_footer flex-wrap ct_mt_20">
                          <div class="ct_project_owner">
                            <img
                              src="../assets/img/girl_7789.png"
                              alt="Olivia Brooks"
                              className="ct_img_40"
                            />
                            <span className="ct_fs_14 ct_darksky_blue_text">
                              Led by Olivia Brooks
                            </span>
                          </div>

                          <a
                            href="#"
                            class="ct_yellow_btn ct_darkblue_btn ct_h_44"
                            onClick={() =>
                              navigate(fundingPaths.FundingProjectFullDetail)
                            }
                          >
                            View Project
                            <i class="fa-solid fa-arrow-right ms-1"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 ct_mb_60">
                  <div class="ct_project_card">
                    <div className="ct_project_card_border_1">
                      <div class="ct_project_img">
                        <img
                          src="../assets/img/project_img_6.png"
                          alt="Solar Learning Initiative"
                        />
                        <span class="ct_verified_badge">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_47963)">
                              <path
                                d="M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"
                                fill="#34C759"
                              />
                              <path
                                d="M17.25 5.25L9.375 13.35L6.75 10.65L4.125 13.35L9.375 18.75L19.875 7.95L17.25 5.25Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_47963">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          Verified
                        </span>
                      </div>

                      <div class="ct_project_content">
                        <h4 class="ct_fs_24_new ct_orange_text mb-5">
                          Solar Learning Initiative
                        </h4>

                        <p class="ct_fs_16 ct_darkblue_text ct_mb_16">
                          Empowering rural schools through solar-powered
                          learning tools
                        </p>

                        <p
                          class="ct_darkblue_text mb-0"
                          style={{ maxWidth: "400px" }}
                        >
                          This mobile education kit brings digital learning to
                          off-grid communities using solar tech and offline
                          content.
                        </p>

                        <div class="ct_project_footer flex-wrap ct_mt_20">
                          <div class="ct_project_owner">
                            <img
                              src="../assets/img/girl_7789.png"
                              alt="Olivia Brooks"
                              className="ct_img_40"
                            />
                            <span className="ct_fs_14 ct_darksky_blue_text">
                              Led by Olivia Brooks
                            </span>
                          </div>

                          <a
                            href="#"
                            class="ct_yellow_btn ct_darkblue_btn ct_h_44"
                            onClick={() =>
                              navigate(fundingPaths.FundingProjectFullDetail)
                            }
                          >
                            View Project
                            <i class="fa-solid fa-arrow-right ms-1"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class=" ct_px_40 ct_py_130">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-lg-8 mb-4 mb-lg-0 "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_content">
                    <h4 class="ct_fs_24_new ct_dakrblue_text">How It Works?</h4>
                    <h3 class="ct_fs_32 ct_dakrblue_text ">
                      Discover, Connect and Invest with Ease
                    </h3>
                  </div>
                  <div class="row mt-5">
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/ri_find-replace-fill.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Explore Projects
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "261px" }}
                          >
                            Browse our curated ideas by category, stage, or
                            impact.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0 ">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/fa6-solid_handshake.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Connect with Founders
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "256px" }}
                          >
                            Reach out directly or request intros through Nuvio
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/uim_bag.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Support Grow
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "256px" }}
                          >
                            Invest, mentor, or partner-track progress along the
                            way.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-4 mb-4 mb-lg-0 ps-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_img">
                    <img
                      src="../assets/img/explore_project_how_works_left_img.png"
                      alt=""
                      style={{ objectFit: "cover", objectPosition: "right" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            data-aos="fade-right"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg ct_looking_for_work_bg_left "
            style={{ backgroundColor: "#8ECAE6", paddingBlock: "134px" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">
                  Invest in Purpose. Empower Innovation.
                </h4>
                <p
                  class="mb-0 ct_fs_18 ct_fw_300"
                  style={{ maxWidth: "747px" }}
                >
                  Every great idea needs a believer. Support founders creating
                  change and be part of something bigger than capital.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  onClick={() =>
                    navigate(coachPaths.ContactUs, {
                      state: { data: "landing" },
                    })
                  }
                >
                  Talk to Us
                </a>
              </div>
            </div>
          </section>

          <section
            class="  ct_px_40 ct_mt_130 "
            style={{ backgroundColor: "#F5F3EF", paddingBlock: "72px" }}
          >
            <div class="container-fluid">
              <div class="row">
                <div
                  class="col-lg-4 mb-4 mb-lg-0"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="d-grid h-100 pt-2 pb-5">
                    <h2
                      class="ct_fs_40 ct_darkblue_text"
                      style={{ maxWidth: "300px" }}
                    >
                      Real Stories, real{" "}
                      <span class="ct_yellow_text">success</span>
                    </h2>
                    <div className="ct_arrows mt-auto">
                      <button className="ct_prev ct_arrow_btn" ref={prevRef}>
                        <i class="fa-solid fa-arrow-left"></i>
                      </button>
                      <button className="ct_next ct_arrow_btn" ref={nextRef}>
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-8 mb-4 mb-lg-0"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{ delay: 2500 }}
                    navigation={{
                      prevEl: prevRef.current,
                      nextEl: nextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                      swiper.params.navigation.prevEl = prevRef.current;
                      swiper.params.navigation.nextEl = nextRef.current;
                    }}
                    className="ct_real_stories_slider"
                  >
                    {/* Slide 1 */}
                    {[1, 2, 3, 4, 5]?.map((item, index) => (
                      <SwiperSlide>
                        <div className="ct_story_slide_card">
                          <div className="ct_story_user_img">
                            <img
                              src="../assets/img/real_succss_img_457.png"
                              alt=""
                            />
                          </div>
                          <div>
                            <div className="ct_orange_text mb-3">
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                            </div>

                            <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                              Climbing Higher with Every Project
                            </h3>

                            <p
                              className="ct_fS_18 ct_darkblue_text"
                              style={{ maxWidth: "402px" }}
                            >
                              NuStar gave me access to exclusive projects that
                              truly challenged and grew my expertise. Today, I
                              lead innovative product initiatives and mentor
                              upcoming tech talents
                            </p>

                            <div className="mt-5">
                              <h4 className="ct_fs_20 ct_darkblue_text">
                                Chloe Adams
                              </h4>
                              <p className="ct_fs_18 ct_darkblue_text">
                                Product Director at Zenith Tech
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </section>

          <section class=" ct_px_40  ct_py_130 pb-0 ">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 ps-md-5 "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_about_cnt">
                    <h2 class=" ct_fs_32  ct_mb_60">
                      Frequently asked questions
                    </h2>

                    <div class="ct_faq_question_main ">
                      <div class="accordion" id="faq_accordionExample">
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faq_one">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_one"
                              aria-expanded="false"
                              aria-controls="collapsefaq_one"
                            >
                              How do I get started as a freelancer on NUVIO?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_one"
                            class="accordion-collapse collapse"
                            aria-labelledby="faq_one"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                These costs can spiral but that didn't seem
                                fair. So our prices work differently. Small
                                businesses often need to do similar things: sell
                                online, book appointments, make reservations. So
                                we offer cheaper, pre-packaged Studio Store apps
                                - that solve these brilliantly.
                              </p>
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                If you’re doing something new, on a bigger
                                scale, or need more flexibility, then Builder
                                Studio is for you. Prices vary depending on the
                                features you need but again, you’ll know exactly
                                what you’re paying upfront.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqtwo">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Two"
                              aria-expanded="true"
                              aria-controls="collapseTwo"
                            >
                              What types of projects can I find on NUVIO?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Two"
                            class="accordion-collapse collapse "
                            aria-labelledby="faqtwo"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                These costs can spiral but that didn't seem
                                fair. So our prices work differently. Small
                                businesses often need to do similar things: sell
                                online, book appointments, make reservations. So
                                we offer cheaper, pre-packaged Studio Store apps
                                - that solve these brilliantly.
                              </p>
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                If you’re doing something new, on a bigger
                                scale, or need more flexibility, then Builder
                                Studio is for you. Prices vary depending on the
                                features you need but again, you’ll know exactly
                                what you’re paying upfront.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqthree">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Three"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Three"
                            >
                              How does payment work?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Three"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqthree"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                These costs can spiral but that didn't seem
                                fair. So our prices work differently. Small
                                businesses often need to do similar things: sell
                                online, book appointments, make reservations. So
                                we offer cheaper, pre-packaged Studio Store apps
                                - that solve these brilliantly.
                              </p>
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                If you’re doing something new, on a bigger
                                scale, or need more flexibility, then Builder
                                Studio is for you. Prices vary depending on the
                                features you need but again, you’ll know exactly
                                what you’re paying upfront.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqFour">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Four"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Four"
                            >
                              What support does NUVIO provide to freelancers?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Four"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqFour"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                These costs can spiral but that didn't seem
                                fair. So our prices work differently. Small
                                businesses often need to do similar things: sell
                                online, book appointments, make reservations. So
                                we offer cheaper, pre-packaged Studio Store apps
                                - that solve these brilliantly.
                              </p>
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                If you’re doing something new, on a bigger
                                scale, or need more flexibility, then Builder
                                Studio is for you. Prices vary depending on the
                                features you need but again, you’ll know exactly
                                what you’re paying upfront.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-xxl-4  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5 "
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_about_img">
                    <img
                      src="../assets/img/faq_img.png"
                      class="ct_img_h_617"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            data-aos="fade-left"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg   ct_mt_100"
            style={{
              paddingTop: "147px",
              paddingBottom: "144px",
              backgroundColor: "#FB8500",
            }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">Are You a Founder With a Vision?</h4>
                <p class="mb-0 ct_fs_18 ct_fw_300">
                  Submit your project today and connect with investors who share
                  your passion.
                </p>
              </div>
              <div class="ct_flex_shrink_0 ms-lg-auto">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  onClick={() => navigate(enterPrisesPaths?.ExploreService)}
                >
                  Explore Services
                </a>
              </div>
            </div>
          </section>
          <div style={{ height: "100px" }}></div>
        </>
      )
      }
    </MenuLayout >
  );
};

export default FundingExploreProject;
